export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ONBF016_RELEASE"] = "onbf-r016";
  ExperimentKeys["BIAB001"] = "biab-001";
  ExperimentKeys["ACQ111"] = "acq-111";
  ExperimentKeys["ACQ123"] = "acq-123";
  ExperimentKeys["ACQ124"] = "acq-124";
  ExperimentKeys["ONBC008"] = "onbc-008";
  ExperimentKeys["ACQ127"] = "acq-127";
  ExperimentKeys["ACQ125"] = "acqci-acq-125";
  ExperimentKeys["ACQ126"] = "acqci-acq-126";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';